<template>
    <div class="project-card">
        <div class="project-card__inner">
            <div class="project-card__header flex between">
                <div class="project-card__image" v-if="img">
                  <a :href="url" v-if="url"><img :src="img.src" :alt="img.alt" :title="img.title"></a>
                  <img v-else :src="img.src" :alt="img.alt" :title="img.title">
                </div>
                <div class="project-card__description" v-if="category && $mqEquals('MOBILE')">
                    {{ category }}
                </div>
                <div class="project-card__info">
                    <div class="project-card__top">
                        <a :href="url" v-if="url" class="project-card__title ">
                            {{ title }}
                        </a>
                        <span v-else class="project-card__title ">
                            {{ title }}
                        </span>

                        <div v-if="datas" class="project-card__tags">
                            <a-badge v-for="(tag, key) in datas" :key="key">{{ tag }}</a-badge>
                        </div>
                    </div>


                    <div class="project-card__description--desktop" v-if="description && $mqAbove('MOBILE')">
                        {{ description }}
                    </div>
                </div>

            </div>

            <div class="project-card__footer flex v-center between">
                <div class="project-card__tags flex-start" v-if="tags && $mqAbove('TABLET')">
                    <a-badge alt v-for="(tag, key) in params.actions" :key="key" :params="tag">
                        <span class="small-edit" :style="'background-image:rl(\''+tag.img+'\')'" :title="tag.title"></span>
                    </a-badge>
                    <a-badge alt v-for="(tag, key) in tags" :key="key">{{ tag }}</a-badge>

                </div>

                <div class="flex project-card__ratingContainer">
                    <div class="project-card__volunteers flex v-center" @click="showResponds">
                        <div class="project-card__volunteers-avatars flex v-center">
                            <div class="project-card__volunteers-avatar" v-for="(item, i) in volunteers" :key="i">
                                <img :src="item.avatar.src" :alt="item.avatar.alt" :title="item.avatar.title">
                            </div>
                        </div>
                        <div class="project-card__volunteers-responds">{{ responds }}</div>
                    </div>
                    <ABtn class="primary w-100" :label="completeInfo[0].messages?.btnTitle" @click.prevent="checkTask(completeInfo[0])" v-if="completeInfo&&completeInfo.length==1"/>
                    <div class="multiTask"  v-if="completeInfo&&completeInfo.length>1">
                      <ABtn class="primary w-100" :class="showedCloseReq?'active':''" :label="completeInfo[0].messages?.btnTitle" @click.prevent="showCloseReq">
                        <template #after>&gt;</template>
                      </ABtn>
                      <div class="closeRequest" v-if="showedCloseReq">
                        <div class="reqLine" v-for="info in completeInfo" @click.prevent="checkTask(info)">
                          <div class="avatar">
                            <AAvatar width="50" :src="info.volunteer.photo" class="ChatMessage__avatar"/>
                          </div>
                          <div class="name">{{info.volunteer.name}}</div>
                        </div>

                      </div>
                    </div>
                    <ABtn  class="primary w-100" :label="compliteBtn.text" @click.prevent="compliteTask" v-if="compliteBtn.text"/>
                    <ABtn  class="primary w-100" :label="reviewBtn[0].title" :href="reviewBtn[0].link" v-if="reviewBtn&&reviewBtn.length==1"/>
                    <div class="multiTask" v-if="reviewBtn&&reviewBtn.length>1">
                      <ABtn class="primary w-100" :class="showedReviewBtn?'active':''" :label="reviewBtn[0].title" @click.prevent="showedReview">
                        <template #after>&gt;</template>
                      </ABtn>
                      <div class="closeRequest" v-if="showedReviewBtn">
                        <a class="reqLine" v-for="info in reviewBtn" :href="info.link">
                          <div class="avatar">
                            <AAvatar width="50" :src="info.volunteer.photo" class="ChatMessage__avatar"/>
                          </div>
                          <div class="name">{{info.volunteer.name}}</div>
                        </a>
                      </div>
                    </div>
                  <div class="project-card__rating flex v-center">
                        <svg class="icon" width="14" height="14" viewBox="0 0 14 14"
                             xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M13.9635 5.06994C13.8719 4.78645 13.6204 4.58511 13.3229 4.5583L9.28216 4.19139L7.68432 0.451504C7.56651 0.177419 7.29819 0 7.00007 0C6.70195 0 6.43364 0.177419 6.31582 0.452145L4.71798 4.19139L0.67656 4.5583C0.379616 4.58575 0.128816 4.78645 0.0366355 5.06994C-0.0555452 5.35342 0.0295858 5.66436 0.254216 5.86036L3.30857 8.53905L2.40791 12.5065C2.34201 12.7982 2.45523 13.0997 2.69727 13.2747C2.82737 13.3687 2.97958 13.4165 3.13307 13.4165C3.26542 13.4165 3.39669 13.3808 3.51451 13.3103L7.00007 11.2271L10.4844 13.3103C10.7393 13.4637 11.0607 13.4497 11.3022 13.2747C11.5444 13.0992 11.6575 12.7975 11.5916 12.5065L10.6909 8.53905L13.7453 5.8609C13.9699 5.66436 14.0557 5.35396 13.9635 5.06994Z"/>
                        </svg>
                        <span>{{ rating_min }}/{{ rating_max }}</span>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <template v-if="completeInfo">
      <ResponseCheckComplete v-for="info in completeInfo" :result="info" />
    </template>
    <RespondList :id="id" :messages="messages" :requestToResponses="requestToResponses"/>
</template>

<script>
/**
 * Карточка проекта https://i.imgur.com/C8v9q0p.png
 */


import {AAvatar, ABadge, ABtn, useAModal, useAProgressBar} from '../ui'
import RespondList from "~/components/popups/RespondApplication/RespondList.vue";
import ResponseCheckComplete from "~/components/popups/RespondApplication/ResponseCheckComplete.vue";
import {ref} from "vue";
import {send} from "../../services/api";

export default {
    name: 'ProjectCard',
    components: {
      AAvatar,
        ResponseCheckComplete,
        RespondList,
        ABadge,
        ABtn,
    },
    inheritAttrs: false,
    emits: ['compliteTask'],
    props: {
        compliteBtn: {
          type: Object,
          default: {}
        },
        completeInfo: {
          type: Object,
          default: {}
        },
        reviewBtn: {
          type: Object,
          default: {}
        },
        title: {
            type: String,
            default: '',
            required: true
        },
        img: {
            type: String,
            default: ''
        },
        id: {
            type: String,
            default: ''
        },
        requestToResponses: {
            type: Object,
            default: {}
        },
        messages: {
            type: Object,
            default: {}
        },
        description: {
            type: String,
            default: ''
        },
        category: {
            type: String,
            default: ''
        },
        data: {
            type: String,
            default: '',
        },
        deadline: {
            type: String,
            default: '',
        },
        responds: {
            type: String,
            default: '',
        },
        rating_min: {
            type: String,
            default: '',
        },
        rating_max: {
            type: String,
            default: '',
        },
        params:{
            type: Object,
            default: {}
        },
        url: {
        type: String,
        default: '',
      },
        volunteers: {
            type: Array,
            default: [],
        },
        tags: {
            type: Array,
            default: [],
        },
        datas: {
            // теги верху карточки
            type: Array,
            default: [],
        },
    },
    setup: (props, ctx) => {
      const ajaxUrl = '/ajax/';
      const modal = useAModal();
      const showedCloseReq = ref(false);
      const showedReviewBtn = ref(false);
      const progress = useAProgressBar();
      const compliteTask = async () => {
        ctx.emit('compliteTask',props.id);

        let formData = new FormData();
        console.log(props)

        formData.append('taskId', props.id);
        formData.append('responseId', props.params.response);
        formData.append('action', 'completeTask');
        // Форму, где вводили эти значения(текст и время) попросили убрать, а эти поля обязательные
        //  поэтому пока заполняю их дефолтными значениями
        formData.append('TEXT', 'Дефолтный текст при заявке на завершение задачи');
        formData.append('TIME', 1);

        progress.show();
        await send(ajaxUrl, {method: "POST"}, formData).then((response) => {
          if(response.error) {
            showNotification('danger','',response.error);
            progress.hide();
          } else if(response.success) {
            showNotification('success','',response.success);
            progress.hide();
            setTimeout(()=>{location.reload();},5000);
          }
        });

        // modal.show('respond-complete');
      }
      const showCloseReq = ()=>{
        showedCloseReq.value = !showedCloseReq.value;
      }
      const showedReview = ()=>{
        showedReviewBtn.value = !showedReviewBtn.value;
      }
      const checkTask = (info) => {
        modal.show('respond-check-complete-'+info.id);
      }
        const showResponds = () => {
          if(props.responds) {
              modal.show('responds-show-'+props.id);
          }

        };
        return {
            compliteTask,
            showedCloseReq,
            showedReviewBtn,
            showedReview,
            showResponds,
            showCloseReq,
            checkTask
        }
    },
}
</script>

<style lang="scss">
.project-card__volunteers {
    cursor: pointer;
}
.project-card {
  margin-bottom: rem(12);


    .multiTask {
      .primary.active {
        background: var(--c-primary-100);
      }
      position: relative;
      .closeRequest {
        position: absolute;
        top: 95%;
        left: 0;
        padding: 10px;
        padding-bottom: 0px;
        background: #00a59e;
        border-bottom-right-radius: 6px;
        border-bottom-left-radius: 6px;
        .reqLine {
          display: flex;
          cursor: pointer;
          width: 100%;
          align-items: center;
          margin-bottom: 10px;
        }
       .avatar {
         padding-right: 10px;
       }
        .name {
          color: #fff;
        }

      }
    }
    &__header {
        border-bottom: 1px solid var(--c-gray-700);
        gap: rem(10);

        @include mobile {
            flex-direction: column;
            border-bottom: unset;
        }

        img {
            max-height: 100%;
        }
    }

    &__inner {
        background: #fff;
        height: 100%;
        box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05), 0px 0px rem(40) rgba(0, 0, 0, 0.1);
        border-radius: var(--br-1);
        /*overflow: hidden;*/
        padding: rem(26) rem(30);

        @include tablet {
            padding: rem(20);
        }
    }

    &__body {
        margin-top: rem(7);
    }

    &__info {
        display: flex;
        flex-direction: column;
        flex: 1;
    }

    &__title {
        font-weight: 600;
        font-size: rem(16);
        line-height: rem(24);
        color: var(--c-gray-100);
        display: -webkit-box;
        max-width: 100%;
        max-height: rem(72);
        height: max-content;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        margin-bottom: rem(15);
    }

    &__category {
        font-size: rem(14);
        line-height: rem(20);
        margin-bottom: rem(7);
        color: var(--c-secondary-200);
    }

    &__deadline {
        margin-top: rem(23);
        min-height: rem(28);

        .a-badge {
            color: var(--c-gray-400);
        }
    }

    &__footer {
        margin-top: rem(32);
        gap: rem(10);
        flex-wrap: wrap;
    }

    &__volunteers {
        &-avatar {
            width: rem(24);
            height: rem(24);
            min-width: rem(24);
            min-height: rem(24);
            border: 2px solid #fff;
            border-radius: 50%;
            overflow: hidden;
            margin-left: rem(-12);

            &:first-child {
                margin-left: 0;
                z-index: 3;
            }

            &:nth-child(2) {
                z-index: 2;
            }

            &:nth-child(3) {
                z-index: 1;
            }

            img {
                object-fit: cover;
                width: 100%;
                height: 100%;
                border-radius: 50%;
            }
        }

        &-responds {
            margin-left: rem(5);
            white-space: nowrap;
            font-size: rem(14);
            line-height: rem(19);
            color: var(--c-primary-200);
            font-weight: 700;
        }
    }

    &__ratingContainer {
        @include mobile {
            width: 100%;
        }
    }

    &__rating {
        color: var(--c-gray-400);
        font-size: rem(14);
        padding-left: 3rem;

        @include tablet {
            padding-left: rem(30);
        }

        @include mobile {
            margin-left: auto;
        }

        .icon {
            margin-right: rem(5);
            fill: currentColor;
        }
    }

    &__tags {
        display: flex;
        gap: rem(10);
        flex-wrap: wrap;
        padding-left: 10px;
        flex: 1;
        max-width: 70%;
        justify-content: flex-end;

        //@include mobile {
        //    display: none;
        //}
    }

    &__description {
        color: var(--c-secondary-200);
        font-weight: 400;
        margin-bottom: rem(7);

        &--desktop {
            font-weight: 400;
            font-size: rem(16);
            line-height: rem(26);
            margin-bottom: rem(25);
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    &__image {
        display: flex;
        justify-content: flex-start;
        margin-bottom: rem(50);
        max-height: rem(80);
        width: rem(100);
        flex: 1 0 rem(100);
        max-width: rem(100);

        img {
          height: auto;
          width: 100%;
            object-fit: contain;
            max-height: rem(80);
        }
    }

    &__top {
        display: flex;
        justify-content: space-between;
        margin-bottom: rem(10);
    }
}
</style>
